import cn from 'classnames';
import Divider from 'ui3/Divider/Divider';
// Styles
import styles from './SectionDivider.module.scss';

type SectionDividerProps = {
  className?: string;
  noBottomMargin?: boolean;
};

const SectionDivider = ({
  className,
  noBottomMargin = false,
}: SectionDividerProps): JSX.Element => {
  return (
    <div
      className={cn(styles.root, className, {
        [styles.noBottomMargin]: noBottomMargin,
      })}
      aria-hidden="true"
    >
      <Divider className={styles.divider} />
    </div>
  );
};

export default SectionDivider;
